module.exports = __webpack_public_path__ + "static/00018.b9991dc0.jpg";